import { gql } from 'graphql-request'

export const GetOfferGql = gql`
  query offer($offerId: UUID!) {
    offer(request: { offerId: $offerId }) {
      offer {
        completedDateTime
        created
        createdBy
        expiryDateTime
        id
        offerFrom
        paymentDate
        personalisedComment
        stationBrand
        stationRecordNumber
        status
        lines {
          id
          brandPartner
          cleanMarketPrice
          cleanOfferPrice
          code
          coreTestColourYZ
          coreTestMicron
          coreTestStapleLengthGreasy
          coreTestStapleStrength
          coreTestVegetableMatterBase
          coreTestYield
          displayValueAdd
          greasyMarketPrice
          greasyOfferPrice
          interlotWarning
          internalReferenceCode
          lineNumber
          mainBaleHeaderPurchaseDescription
          netKg
          purchaseAccountName
          qualityScheme2
          qualitySchemeWarning
          saleNumber
          season
          stationBrand
          stationRecordNumber
          status
          totalBales
          typeCurrent
          valueAdd
        }
      }
    }
  }
`
